import { SxProps, Theme } from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';

import { MobileBody } from '../Typography';

export interface IconTextProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  color?: 'primary' | 'secondary' | 'inherit' | 'textSecondary';
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

const IconText: React.FC<IconTextProps> = ({
  icon,
  children,
  color = 'textSecondary',
  size = 'small',
  sx,
}) => {
  const iconFontSize = size === 'small' ? '1.25rem' : '1.5rem';

  return (
    <Stack direction="row" alignItems="center" spacing={1.5} sx={sx}>
      <Stack
        component="span"
        sx={{
          color: (theme) => {
            if (color === 'textSecondary') return theme.palette.text.secondary;
            if (color === 'inherit') return 'inherit';
            return theme.palette[color].main;
          },
          fontSize: iconFontSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiSvgIcon-root': {
            fontSize: 'inherit',
          },
        }}
      >
        {icon}
      </Stack>
      <MobileBody component="span" sx={{ color: 'text.primary' }}>
        {children}
      </MobileBody>
    </Stack>
  );
};

export default IconText;
